import React from "react";
import {
  Responsive,
  Divider,
  Grid,
  Header,
  Segment,
  Table,
  Form,
  Button,
  Message,
  Input,
  Popup,
  Label,
  Radio,
} from "semantic-ui-react";
import numeral from "numeral";

class MakePayment extends React.Component {
  constructor() {
    super();

    this.state = {
      firstName: "",
      lastName: "",
      totalAmount: "",
      amountToPay: "",
      packageId: "",
      editedPrice: "",
      itemCode: "",
      packageNo: "",
      packageName: "",
      plans: [],
      changePlans: null,
      renewPlan: null,
      refillPlan: null,
      activateTime: "0",
    };
  }

  componentDidMount() {
    const { packages } = this.props;
    let firstName = "";
    let lastName = "";
    let plans = [];
    let plan = [];
    let changePlans = [];
    let renewPlan = [];
    let refillPlan = [];
    let activateTime = "0";

    if (packages && packages.customer.refill) {
      refillPlan = packages.customer.refill;
    }

    if (packages && packages.customer) {
      firstName = packages.customer.firstName;
      lastName = packages.customer.lastName;
    }
    if (packages && packages.customer && packages.customer.renewPlan) {
      renewPlan = packages.customer.renewPlan;
    }
    if (packages && packages.customer && packages.customer.changePlans) {
      changePlans = packages.customer.changePlans;
      // plan = [...changePlans];
    }

    plan = [...changePlans];

    plans = plan.map((item) => ({
      ...item,
      toPay: item.price,
      editedPrice: item.price,
      isChecked: false,
      showEdit: true,
    }));

    this.setState({
      firstName,
      lastName,
      plans,
      renewPlan,
      changePlans,
      refillPlan,
      activateTime,
    });
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value.trim() });
  };

  handleActivateTimeChange = (event, {name, value, label}) => {
    let { activateTime } = this.state;
    activateTime = value;
    this.setState({ activateTime });
}

  scrollToPaymentField = () => {
    const element = document.querySelector('div[class="payment-goto"]');
    window.scroll({
      behavior: "smooth",
      top: element.offsetTop + 50,
    });
  };

  onSelectItemPrice = (index) => () => {
    const { plans } = this.state;
    const amount = plans[index]["totalCostWithTax"];
    const total = amount;
    const packId = plans[index]["packageId"];
    const packNo = plans[index]["packageNo"];
    const productCode = plans[index]["itemCode"];
    const packName = plans[index]["name"];
    this.setState({
      amountToPay: amount,
      totalAmount: total,
      packageId: packId,
      packageNo: packNo,
      editedPrice: "",
      itemCode: productCode,
      packageName: packName,
    });
    // TODO: make activateTime radio buttons visible
    // TODO: make them invisible for other options
    this.scrollToPaymentField();
  };

  onSelectRenewItemPrice = (index) => () => {
    const { renewPlan } = this.state;
    const amount = renewPlan[index]["totalCostWithTax"];
    const total = amount;
    const packId = renewPlan[index]["packageId"];
    const packNo = renewPlan[index]["packageNo"];
    const productCode = renewPlan[index]["itemCode"];
    const packName = renewPlan[index]["name"];
    this.setState({
      amountToPay: amount,
      totalAmount: total,
      packageId: packId,
      packageNo: packNo,
      editedPrice: "",
      itemCode: productCode,
      packageName: packName,
    });
    this.scrollToPaymentField();
  };

  updateItemPrice = () => {
    const { editedPrice, refillPlan } = this.state;
    const total = parseInt(Math.round(editedPrice).toFixed(2));

    this.setState({
      amountToPay: editedPrice,
      totalAmount: total,
      packageId: refillPlan[0]["packageId"],
      itemCode: refillPlan[0]["itemCode"],
      packageName: refillPlan[0]["name"],
    });

    this.scrollToPaymentField();
  };

  getCurrentDate = () => {
    var date = new Date().getDate();
    var month = new Date().getMonth() + 1;
    var year = new Date().getFullYear();

    return date + "/" + month + "/" + year;
  };

  pay = () => {
    const { requestData, makePayment } = this.props;
    const {
      firstName,
      lastName,
      packageId,
      packageNo,
      totalAmount,
      amountToPay,
      itemCode,
      packageName,
      activateTime,
    } = this.state;
    const data = {};
    const items = [
      {
        // paymentDate: today.getFullYear() + '/' + (today.getMonth() + 1) + '/' + today.getDate(),
        // paymentDate: moment(new Date()).format("DD/MM/YYYY"),
        packageId: packageId,
        packageNo: packageNo,
        itemCode: itemCode,
        amountDue: totalAmount,
        amountPaid: amountToPay,
        packageName: packageName,
      },
    ];
    data.accountId = requestData.accountId;
    data.firstName = firstName;
    data.lastName = lastName;
    data.package = items;
    data.activateTime = activateTime;
    makePayment(data);
  };

  render() {
    const {
      firstName,
      lastName,
      totalAmount,
      plans,
      editedPrice,
      renewPlan,
      activateTime,
    } = this.state;
    const { isPaying, back } = this.props;

    if (!plans.length) {
      return (
        <React.Fragment>
          <Divider hidden />
          <Divider />
          <Divider hidden />
          <Message
            info
            icon="exclamation triangle"
            header="No packages found"
            onDismiss={() => back()}
          />
        </React.Fragment>
      );
    }

    const renewData = renewPlan.map((item, index) => (
      <Table.Row key={item.itemCode}>
        <Responsive as="td" minWidth="767">
          <Label
            ribbon
            content={`₦${numeral(item.totalCostWithTax).format("0,0.00")}`}
          />
        </Responsive>
        <Table.Cell>
          <Popup
            trigger={
              <div className="table_content_div">
                <p>
                  <span> {item.description}</span>
                </p>
              </div>
            }
            content={item.description}
            size="mini"
            flowing
            hoverable
            inverted
            style={{ width: "50%" }}
          />
        </Table.Cell>
        <Table.Cell>
          <React.Fragment>
            <span
              style={{ marginRight: 8, fontWeight: 700, fontSize: "1.1rem" }}
            >
              &#8358; {numeral(item.totalCostWithTax).format("0,0.00")}
            </span>
            <Button
              size="mini"
              floated="right"
              style={{ marginTop: "-.25em" }}
              onClick={this.onSelectRenewItemPrice(index)}
            >
              select
            </Button>
          </React.Fragment>
        </Table.Cell>
      </Table.Row>
    ));

    const tableData = plans.map((item, index) => (
      <Table.Row key={index}>
        <Responsive as="td" minWidth="767">
          <Label
            ribbon
            content={`₦${numeral(item.totalCostWithTax).format("0,0.00")}`}
          />
        </Responsive>
        <Table.Cell>
          <Popup
            trigger={
              <div className="table_content_div">
                <p>
                  <span>{item.description}</span>
                </p>
              </div>
            }
            content={item.description}
            size="mini"
            flowing
            hoverable
            inverted
            style={{ width: "50%" }}
          />
        </Table.Cell>
        <Table.Cell>
          <React.Fragment>
            <span
              style={{ marginRight: 8, fontWeight: 700, fontSize: "1.1rem" }}
            >
              &#8358; {numeral(item.totalCostWithTax).format("0,0.00")}
            </span>
            <Button
              size="mini"
              floated="right"
              style={{ marginTop: "-.25em" }}
              onClick={this.onSelectItemPrice(index)}
            >
              select
            </Button>
          </React.Fragment>
        </Table.Cell>
      </Table.Row>
    ));

    return (
      <React.Fragment>
        <Divider hidden />
        <Divider />
        <Divider hidden />
        <Grid>
          <Grid.Row>
            <Grid.Column computer={3} tablet={16} mobile={16}>
              <label className="label-bold">Customer Name</label>
            </Grid.Column>

            <Grid.Column computer={13} tablet={16} mobile={16}>
              <Header as="h5" textAlign="center" block>
                {firstName + "     " + lastName}
              </Header>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Divider hidden />
            <Grid.Column computer={3} tablet={16} mobile={16}>
              <label className="label-bold">Refill Amount:</label>
            </Grid.Column>

            <Grid.Column computer={13} tablet={16} mobile={16}>
              <Form.Group>
                <React.Fragment>
                  <Form.Field className="table-input" width={1}>
                    <Input
                      action={{
                        color: "blue",
                        icon: "check",
                        onClick: () => this.updateItemPrice(),
                      }}
                      actionPosition="right"
                      placeholder="Amount"
                      type="number"
                      value={editedPrice}
                      name="editedPrice"
                      onChange={this.handleInputChange}
                    />
                  </Form.Field>
                </React.Fragment>
              </Form.Group>
            </Grid.Column>

            <Divider />
          </Grid.Row>

          {renewPlan.length === 0 ? (
            <Grid.Row>
              <Grid.Column computer={3} tablet={16} mobile={16}>
                <label className="label-bold"> No Current Package:</label>
              </Grid.Column>
            </Grid.Row>
          ) : (
            <Grid.Row>
              <Grid.Column computer={3} tablet={16} mobile={16}>
                <label className="label-bold"> Current Package:</label>
              </Grid.Column>

              <Grid.Column computer={13} tablet={16} mobile={16}>
                <Segment className="fixed-table" loading={false}>
                  <Table
                    compact
                    celled
                    singleLine
                    selectable
                    size="small"
                    color="blue"
                  >
                    <Table.Header>
                      <Table.Row>
                        <Responsive as="th" minWidth="767" />
                        <Table.HeaderCell />
                        <Table.HeaderCell>
                          {/* <Checkbox
                          style={{ zIndex: 0 }}
                          checked={toggledAll}
                          onChange={this.handleToggleAll}
                        /> */}
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>{renewData}</Table.Body>
                  </Table>
                </Segment>
              </Grid.Column>
            </Grid.Row>
          )}
          <Divider hidden />

          <Grid.Row>
            <Grid.Column computer={3} tablet={16} mobile={16}>
              <label className="label-bold">Package(s):</label>
            </Grid.Column>

            <Grid.Column computer={13} tablet={16} mobile={16}>
              <Segment className="fixed-table" loading={false}>
                <Table
                  compact
                  celled
                  singleLine
                  selectable
                  size="small"
                  color="blue"
                >
                  <Table.Header>
                    <Table.Row>
                      <Responsive as="th" minWidth="767" />
                      <Table.HeaderCell />
                      <Table.HeaderCell>
                        {/* <Checkbox
                          style={{ zIndex: 0 }}
                          checked={toggledAll}
                          onChange={this.handleToggleAll}
                        /> */}
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>{tableData}</Table.Body>
                </Table>
              </Segment>
            </Grid.Column>
          </Grid.Row>

          <Divider hidden />

          <Form.Field>
            <Grid>
              <Grid.Row>
                <Grid.Column computer={11} tablet={8} mobile={16}>
                  <Responsive maxWidth={991}>
                    <label className="label-bold">Activate when:</label>
                  </Responsive>
                  <Responsive minWidth={992}>
                    <Header>Activate when:</Header>
                  </Responsive>
                </Grid.Column>
                <Grid.Column computer={13} tablet={16} mobile={16}>
                  <Header as="h5" textAlign="right" block>
                    <Grid.Column width='8'>
                        <Radio 
                            name='activateTime'
                            label='Immediately'
                            value = '0'
                            onChange={this.handleActivateTimeChange}
                            checked={activateTime === "0"} />
                    </Grid.Column>
                    <Grid.Column width='8'>
                        <Radio 
                            name='activateTime'
                            label='At End of Current Plan'
                            value = '1'
                            onChange={this.handleActivateTimeChange}
                            checked={activateTime === "1"} />
                    </Grid.Column>
                    </Header>
                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form.Field>

          <div className="payment-goto">
            <Grid.Row>
              <Grid.Column computer={11} tablet={8} mobile={16}>
                <Responsive maxWidth={991}>
                  <label className="label-bold">Payment Amount:</label>
                </Responsive>
                <Responsive minWidth={992}>
                  <Header>Payment Amount:</Header>
                </Responsive>
              </Grid.Column>

              <Grid.Column computer={5} tablet={8} mobile={16}>
                <Header as="h5" textAlign="right" block>
                  &#8358; {numeral(totalAmount).format("0,0.00")}
                </Header>
              </Grid.Column>
            </Grid.Row>
          </div>

          <Grid.Row>
            <Grid.Column>
              <Button
                labelPosition="left"
                floated="right"
                color="blue"
                content="Continue"
                icon="arrow right"
                loading={isPaying}
                disabled={isPaying}
                onClick={this.pay}
              />
              <Button
                basic
                labelPosition="left"
                floated="left"
                content="Back"
                icon="undo"
                onClick={back}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </React.Fragment>
    );
  }
}

export default MakePayment;
